module.exports = __webpack_public_path__ + "img/take-photo-step.b70e2f6a.svg";